module.exports = __webpack_public_path__ + "static/media/faqBalance-en-hi.742c5258.vtt";